export default {
  'app.nome': 'SPA Sensorial',
  'app.sottotitolo': 'Relais Villa Carola',
  'avvio.carico': 'Avvio…',
  'avvio.errore': 'Non riesco ad avviare l\'app. Controlla la rete e riapri.',
  'avvio.riprova': 'Riprova',
  'rete.no': 'Senza rete: tutto resta salvato sul telefono',
  'invii.telefono': '⏳ Salvato sul telefono · parte appena c\'è rete',
  'invii.arrivato': '✓ Arrivato',
  'invii.errore': '⚠️ Non salvato ({codice})',
  'attesa.titolo': 'Benvenuta nella SPA',
  'attesa.spiega': 'Scrivi il tuo nome e chiedi di entrare. La responsabile approva il telefono.',
  'attesa.nome': 'Il tuo nome',
  'attesa.invia': 'Chiedi di entrare',
  'attesa.inviata': 'Richiesta inviata. Aspetta l\'approvazione della responsabile: questa pagina si aggiorna da sola.',
  'attesa.disattivo': 'Questo telefono è stato disattivato. Chiedi alla responsabile.',
  'attesa.codice': 'Codice del telefono: {codice}',
  'attesa.lingua': 'Lingua',
  'agenda.titolo': 'Agenda',
  'agenda.oggi': 'Vai a oggi',
  'agenda.prima': 'Giorno prima',
  'agenda.dopo': 'Giorno dopo',
  'agenda.filtro': 'Mostra le prenotazioni di',
  'agenda.tutte': 'Tutte',
  'agenda.tratt1': '1 trattamento',
  'agenda.trattN': '{n} trattamenti',
  'agenda.compl': 'compl. {v}',
  'agenda.noShowDecidere': '{n} no-show da decidere',
  'agenda.liberoFino': 'libero fino alle {ora}',
  'agenda.riordino': 'riordino {n}\'',
  'agenda.conLettino': 'con L{n}',
  'agenda.vuota': 'Nessuna prenotazione',
  'agenda.lettino': 'Lettino {n}',
  'agenda.ospite': 'ospite',
  'agenda.inCarico': 'Carico l\'agenda…',
  'agenda.inSospeso': 'in attesa di rete',
  'stato.confermata': 'Confermata',
  'stato.arrivato': 'Ospite arrivato',
  'stato.fatto': 'Fatto',
  'stato.disdetta': 'Disdetta',
  'stato.no-show': 'No-show',
  'richieste.titolo': 'Telefoni da approvare',
  'richieste.approva': 'Approva',
  'richieste.rifiuta': 'Rifiuta',
  'richieste.colonna': 'Colonna operatrice',
  'richieste.nessuna': 'nessuna',
  'richieste.scegliRuolo': 'Scegli almeno un ruolo.',
  'ruolo.responsabile': 'Responsabile',
  'ruolo.operatrice': 'Operatrice',
  'ruolo.ricevimento': 'Ricevimento',
  'ruolo.dev': 'Sviluppo',
  'agenda.prenota': '+ Prenota',
  'agenda.libero': 'libero',
  'agenda.coppia': 'coppia',
  'agenda.fuoriServizio': 'fuori servizio',
  'stato.disdettaTardiva': 'Disdetta tardiva · addebito',
  'stato.disdettaGratuita': 'Disdetta gratuita',
  'stato.noShowAddebito': 'No-show · addebito',
  'stato.noShowGratis': 'No-show · nessun addebito',
  'stato.noShowDaDecidere': 'No-show · addebito da decidere',
  'op.n': 'Operatrice {n}',
  'op.breve': 'Op. {n}',
  'foglio.chiudi': 'Chiudi',
  'tipo.pagamento': 'A pagamento',
  'tipo.voucher': 'Voucher regalo',
  'tipo.complimentary': 'Complimentary',
  'tipo.proprieta': 'Conto proprietà',
  'tag.voucher': 'voucher',
  'tag.complimentary': 'complimentary',
  'tag.proprieta': 'proprietà',
  'importo.pagamento': 'Importo €',
  'importo.voucher': 'Valore € (già pagato)',
  'importo.complimentary': 'Valore € (offerto)',
  'importo.proprieta': 'Valore € (proprietà)',
  'paga.pos': 'POS (carta)',
  'paga.contanti': 'Contanti',
  'paga.dadecidere': 'Da decidere',
  'modulo.nuova': 'Nuova prenotazione',
  'modulo.modifica': 'Modifica',
  'modulo.ospite': 'Ospite',
  'modulo.camera': 'Camera',
  'modulo.cameraEs': '307 o EST.',
  'modulo.nome': 'Nome',
  'modulo.esterno': 'Ospite esterno (non dorme in hotel)',
  'modulo.telefono': 'Telefono',
  'modulo.email': 'Email',
  'modulo.paga': 'Paga in SPA con',
  'modulo.caparra': 'Caparra €',
  'modulo.esternoSpiega': 'Niente conto camera: paga in SPA. Telefono o email servono per avvisarlo.',
  'modulo.coppia': 'Coppia: due lettini nella stessa sala',
  'modulo.inCoppia': 'Fa parte di una coppia: qui modifichi solo questa persona.',
  'modulo.trattamento': 'Trattamento',
  'modulo.seconda': 'Seconda persona',
  'modulo.nome2Vuoto': 'se vuoto, uguale alla prima',
  'modulo.operatrice': 'Operatrice',
  'modulo.giorno': 'Giorno',
  'modulo.ora': 'Ora',
  'modulo.primoLibero': 'Trova il primo orario libero',
  'modulo.libero': 'Libero: {ora} · {dove} · {chi}',
  'modulo.liberoNo': 'Nessun orario libero in questo giorno per questo trattamento.',
  'modulo.liberoGiorno': 'Prima scegli il giorno.',
  'modulo.sala': 'Sala',
  'modulo.lettino': 'Lettino',
  'modulo.durata': 'Durata (min)',
  'modulo.pagamento': 'Pagamento',
  'modulo.prezzoIgnoto': 'prezzo ?',
  'modulo.listino': 'Listino: {prezzo}',
  'modulo.listino2': '1ª {a} · 2ª {b}',
  'modulo.motivoSconto': 'Motivo sconto / durata ridotta',
  'modulo.scontoEs': 'es. durata ridotta a 30\', richiesta del cliente',
  'modulo.motivoCompl': 'Motivo del complimentary',
  'modulo.complEs': 'es. honey moon, offerto dalla direzione',
  'modulo.magg': 'Ospite maggiorenne (18+)',
  'modulo.carico': 'Carico i dati del giorno…',
  'modulo.annulla': 'Annulla',
  'modulo.salvaNuova': 'Salva prenotazione',
  'modulo.salvaModifiche': 'Salva modifiche',
  'modulo.quandoDove': 'Quando e dove',
  'modulo.dalListino': 'Dal listino',
  'modulo.daSoli': 'durata e importo si compilano da soli',
  'modulo.tipo': 'Tipo',
  'modulo.controlli': 'Controlli',
  'modulo.tuttoOk': 'Posto libero: lettino, sala in servizio, operatrice in turno e fuori dalla pausa pranzo.',
  'modulo.soloServer': '«Salvata» compare solo dopo la conferma del server.',
  'salute.titolo': 'Salute · solo personale SPA',
  'salute.titoloN': 'Salute {n}ª persona · solo personale SPA',
  'salute.grav': 'Gravidanza',
  'salute.all': 'Allergie o sensibilità',
  'salute.note': 'Note',
  'salute.spiega': 'Restano nell\'app SPA. Non vanno mai al ricevimento.',
  'salute.salva': 'Salva salute',
  'salvato.nuova': '✓ Prenotazione salvata',
  'salvato.modifica': '✓ Modifica salvata',
  'salvato.stato': '✓ Salvato: {stato}',
  'salvato.salute': '✓ Scheda salute salvata',
  'salvato.turni': '✓ Turni salvati',
  'salvato.addebito': '✓ Addebito salvato',
  'scheda.addebitoNoShow': 'Addebito no-show',
  'scheda.daDecidere': 'da decidere (la responsabile)',
  'scheda.ospite':'Ospite',
  'scheda.trattamento': 'Trattamento',
  'scheda.operatrice': 'Operatrice',
  'scheda.pagamento': 'Pagamento',
  'scheda.esterno': 'Esterno',
  'scheda.sconto': 'Sconto',
  'scheda.coppiaCon': 'In coppia con',
  'scheda.nota': 'Nota',
  'scheda.senzaCamera': 'camera non scritta',
  'scheda.senzaContatti': 'nessun contatto',
  'scheda.pagaIn': 'paga in SPA: {come}',
  'scheda.caparra': 'caparra {importo}',
  'scheda.listinoDurata': 'listino {durata}\'',
  'scheda.listinoPrezzo': 'listino {prezzo}',
  'scheda.modifica': 'Modifica',
  'scheda.indietro': 'Indietro',
  'scheda.storico': 'Storico ({n})',
  'scheda.nonTrovata': 'Prenotazione non trovata.',
  'azione.arrivato': 'Ospite arrivato',
  'azione.fatto': 'Trattamento fatto',
  'azione.no-show': 'No-show',
  'azione.disdetta': 'Disdici',
  'azione.confermata': 'Riporta a confermata',
  'disdetta.gratuita': 'Mancano {ore} ore: disdetta gratuita.',
  'disdetta.tardiva': 'Mancano meno di 24 ore: si addebita l\'intero importo ({importo}).',
  'disdetta.tardivaGratis': 'Mancano meno di 24 ore: addebito pieno, ma questo trattamento non si paga.',
  'disdetta.conferma': 'Conferma disdetta',
  'noshow.testo': 'L\'ospite non si è presentato.',
  'noshow.daDecidere': 'L\'importo da addebitare lo decide la responsabile.',
  'noshow.importo': 'Quanto si addebita? (da 0 a {max})',
  'noshow.errore': 'Scrivi un importo da 0 a {max}.',
  'noshow.conferma': 'Conferma no-show',
  'noshow.decidi': 'Scrivi l\'addebito',
  'noshow.cambia': 'Cambia l\'addebito',
  'noshow.salva': 'Salva addebito',
  'evento.crea': 'Creata',
  'evento.modifica': 'Modificata',
  'evento.dove': '{ora}, {sala} {lettino}, {op}',
  'evento.stato': 'Stato: {stato}',
  'evento.nota.tardiva': 'tardiva',
  'evento.nota.gratuita': 'gratuita',
  'evento.salute': 'Scheda salute aggiornata',
  'evento.addebito': 'Addebito no-show: {importo}',
  'evento.addebitoInStato': 'addebito {importo}',
  'turni.titolo': 'Turni e pause',
  'turni.apri': 'Turni e pause',
  'turni.in': 'in turno',
  'turni.fuori': 'non in turno',
  'turni.conPausa': 'in turno · pausa {da}–{a}',
  'turni.nome': 'Nome',
  'turni.inTurno': 'In turno',
  'turni.pausa': 'Pausa pranzo (P.P)',
  'turni.nessunaPausa': 'Nessuna pausa',
  'turni.spiega': 'Nel foglio: grigio = non in turno, arancio «P.P» = pausa. Qui bloccano le prenotazioni da sole.',
  'turni.spiegaNomi': 'Il nome vale per tutti i giorni. Vuoto = «Operatrice N».',
  'turni.conflitto': 'Da spostare · {ora} {nome}: {problema}',
  'turni.salva': 'Salva',
  'ctrl.fuoriOrario': 'Fuori orario: la SPA lavora dalle {da} alle {a} (questo finirebbe alle {fine}).',
  'ctrl.fuoriTurno': '{op} non è in turno il {giorno}.',
  'ctrl.pausa': '{op} è in pausa pranzo (P.P) dalle {da} alle {a}.',
  'ctrl.fuoriServizio': '{sala} {lettini} fuori servizio dalle {da} alle {a}: {motivo}.',
  'ctrl.lettinoN': 'lettino {n}',
  'ctrl.tuttiLettini': 'tutti e 2 i lettini',
  'ctrl.lettinoOccupato': 'Lettino occupato: {sala} {lettino} ha {nome} dalle {da} alle {a}, più {riordino}\' di riordino.',
  'ctrl.unOspite': 'un ospite',
  'ctrl.impegnata': '{op} è già impegnata con {nome} dalle {da} alle {a}.',
  'ctrl.giorno': 'Scegli il giorno.',
  'ctrl.nome': 'Scrivi il nome dell\'ospite.',
  'ctrl.magg': 'Conferma che l\'ospite è maggiorenne: la SPA accetta solo dai 18 anni.',
  'ctrl.motivoCompl': 'Scrivi il motivo del complimentary (es. honey moon).',
  'ctrl.coppiaOp': 'Per la coppia servono due operatrici diverse.',
  'ctrl.coppiaSala': 'La coppia usa i due lettini della stessa sala.',
  'ctrl.durata': 'Durata: scrivi i minuti, da 15 a 240.',
  'ctrl.importo': 'Importo: scrivi un numero da 0 in su.',
  'ctrl.motivoSconto': 'Prezzo o durata sotto il listino: scrivi il motivo (es. durata ridotta, richiesta del cliente).',
  'ctrl.solo': '«{tr}» si fa solo per una persona: non si può prenotare in coppia.',
  'ctrl.trattamento': 'Scegli il trattamento.',
  'ctrl.persona': '{n}ª persona: ',
  'ctrl.prezzoIgnoto': '{chi}il prezzo di «{tr}» non è ancora nel listino. Scrivilo a mano.',
  'ctrl.importoZero': '{chi}importo a 0 €.',
  'ctrl.durataDaConf': '{chi}durata di «{tr}» da confermare: per ora {durata}\'.',
  'ctrl.salaSolita': '«{tr}» di solito si fa nella sala {sala}.',
  'ctrl.camera': 'Camera vuota: scrivi il numero, oppure spunta «Ospite esterno».',
  'ctrl.estContatti': 'Ospite esterno: scrivi telefono o email, servono per avvisarlo.',
  'ctrl.email': 'Email scritta male: controllala.',
  'ctrl.caparraNeg': 'Caparra: scrivi un numero da 0 in su.',
  'ctrl.caparraAlta': 'Caparra ({caparra}) più alta del totale ({totale}).',
  'ctrl.estProprieta': 'Ospite esterno con «Conto proprietà»: controlla il pagamento.',
  'ctrl.grav': 'Gravidanza: controlla che il trattamento sia adatto prima di confermare.',
  'barra.titolo': 'Sezioni',
  'barra.oggi': 'Oggi',
  'barra.agenda': 'Agenda',
  'oggi.luogo': 'Villa Carola',
  'oggi.tratt1': 'trattamento oggi',
  'oggi.trattN': 'trattamenti oggi',
  'oggi.occupati': 'lettini occupati',
  'oggi.incasso': 'incasso del giorno',
  'oggi.prossimi': 'Prossimi',
  'oggi.vaiAgenda': 'Agenda ›',
  'oggi.nessuno': 'Nessun altro trattamento oggi.',
  'oggi.daSapere': 'Da sapere oggi',
  'oggi.niente': 'Niente da segnalare.',
  'oggi.coppia': '{tr} · coppia',
  'oggi.lettino': '{sala} L{n}',
  'oggi.lettini': '{sala} L1 e L2',
  'oggi.due': '{a} e {b}',
  'barra.richieste': 'Richieste',
  'oggi.richiesteRvc': 'Richieste da RVC da rispondere: {n}',
  'ponte.luogo': 'Ricevimento',
  'ponte.titolo': 'Richieste',
  'ponte.conta': '{n} da rispondere · arrivano da RVC',
  'ponte.spento': 'Il ponte con RVC non è acceso.',
  'ponte.nonRaggiungibile': 'Ponte con RVC non raggiungibile: riprovo da solo.',
  'ponte.controllato': 'Ponte controllato alle {ora}',
  'ponte.nessuna': 'Nessuna richiesta da rispondere.',
  'ponte.nessunaFatta': 'Nessuna richiesta risposta.',
  'ponte.fatte': 'Già risposte',
  'ponte.regola24': 'Disdetta gratis fino a 24 ore prima. Dopo, l\'addebito lo decide la responsabile.',
  'ponte.oggi': 'Oggi',
  'ponte.domani': 'Domani',
  'ponte.camera': 'Camera {n}',
  'ponte.esterno': 'Ospite esterno',
  'ponte.coppia': 'coppia',
  'ponte.arrivata': 'arrivata {ora} · {chi}',
  'ponte.prima': 'prima: {quando}',
  'ponte.posto': '{sala} L{n} libera · {op} in turno, fuori dalla pausa',
  'ponte.postoCoppia': '{sala} L1 e L2 liberi · {a} e {b} in turno',
  'ponte.occupato': 'Alle {ora} non c\'è posto.',
  'ponte.passata': 'L\'ora chiesta è già passata.',
  'ponte.primoLibero': 'Primo orario libero: {quando} · {dove}',
  'ponte.giaGiusta': 'La prenotazione è già a questo giorno e a quest\'ora.',
  'ponte.spostaCoppia': 'Coppia: sposta le due prenotazioni dall\'agenda, poi conferma.',
  'ponte.errore.azione': 'Richiesta non chiara (azione sconosciuta): rifiutala e chiama il ricevimento.',
  'ponte.errore.data': 'Giorno non valido: rifiutala e chiama il ricevimento.',
  'ponte.errore.ora': 'Ora non valida: rifiutala e chiama il ricevimento.',
  'ponte.errore.trattamento': 'Trattamento non nel listino della SPA: rifiutala e chiama il ricevimento.',
  'ponte.errore.persone': 'Numero di persone non valido per questo trattamento: rifiutala e chiama il ricevimento.',
  'ponte.errore.cliente': 'Manca la camera o il nome dell\'ospite esterno: rifiutala e chiama il ricevimento.',
  'ponte.errore.tipo': 'Pagamento sconosciuto: rifiutala e chiama il ricevimento.',
  'ponte.conferma': 'Conferma',
  'ponte.proponi': 'Proponi {ora}',
  'ponte.apri': 'Apri la prenotazione',
  'ponte.disdici': 'Apri per disdire',
  'ponte.rifiuta': 'Rifiuta',
  'ponte.rifiutaSicuro': 'Tocca ancora per rifiutare',
  'ponte.daRvc': 'Richiesta del ricevimento (RVC)',
  'ponte.chiesta': 'Chiesta da {chi} per {quando} alle {ora}. Giorno e ora restano quelli chiesti.',
  'ponte.salvataConferma': '✓ Prenotazione salvata e confermata a RVC',
  'ponte.salvata.confermata': '✓ Confermata a RVC',
  'ponte.salvata.altro-orario': '✓ Proposta mandata a RVC',
  'ponte.salvata.rifiutata': '✓ Rifiutata: RVC lo vede',
  'ponte.sulTelefono': '⏳ salvata sul telefono',
  'ponte.inInvio': 'in invio a RVC…',
  'ponte.mandata': 'RVC avvisato',
  'ponte.stato.confermata': 'Confermata',
  'ponte.stato.altro-orario': 'Altro orario',
  'ponte.stato.proposta': 'Proposto {quando}',
  'ponte.stato.rifiutata': 'Rifiutata',
  'ponte.stato.annullata': 'Annullata da RVC',
};
